import { Pipe, PipeTransform } from '@angular/core';

/**
 * PhonePipe transforms a phone number into a cleaned, pretty value
 */
@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    const original = value || '';

    // Get the digits in the phone number
    const cleaned = original.replace(/\D/g, '');

    // Match the digits to a 10 number sequence
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    // If the match was successful, return the pretty output. Otherwise, return the original
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : original;
  }
}
